<template>
    <section id="location-box" data-cy="location-box">
        <v-card class="location-box-content" elevation="5">
            <div class="location-box__actions">
                <v-select
                    v-model="models.selectedLocation"
                    class="location-box__selection"
                    label="Select a Location"
                    placeholder="Select a Location"
                    :items="sortedPermissionsList"
                    itemText="friendly"
                    itemValue="id"
                    returnObject
                    dense
                    outlined
                    hideDetails
                />
                <!-- Back Button -->
                <ClButton
                    type="secondary"
                    aria-label="Back"
                    title="Back"
                    @click="backButtonHandler()"
                >
                    Back
                </ClButton>
            </div>
        </v-card>
    </section>
</template>

<script>
// Vuex
import { mapGetters, mapState } from 'vuex';

export default {
    name: 'TheLocationBox',
    data() {
        return {
            models: {
                selectedLocation: {},
                showToast: true,
            },
        };
    },
    computed: {
        ...mapGetters( {
            hasPermissions: 'User/hasPermissions',
        } ),
        ...mapState( {
            username: ( state ) => state.User.username,
            password: ( state ) => state.User.password,
            currentUserPermissionsList: ( state ) => state.User.permissions.list,
        } ),

        /** @returns { Array } */
        sortedPermissionsList() {
            return this.hasPermissions
                ? Object.values( this.currentUserPermissionsList )
                    .sort( ( a, b ) => a.friendly.localeCompare( b.friendly ) )
                : [];
        },

        /** @returns { Boolean } */
        hasSelectedLocation() {
            return Object.values( this.models.selectedLocation ).length > 0;
        },
    },
    watch: {
        // This auto-logs in the user after they select a location from the dropdown
        hasSelectedLocation() {
            if ( this.hasSelectedLocation ) this.continueButtonHandler();
        },
    },
    methods: {
        async backButtonHandler() {
            await this.$store.dispatch( 'User/logout' );
            this.$emit( 'cancel' );
        },
        async continueButtonHandler() {
            if ( this.hasSelectedLocation ) {
                await this.$store.dispatch( 'setUserLocationGetWebsiteInfoGoHome', {
                    locationId: this.models.selectedLocation.locationId,
                    locationName: this.models.selectedLocation.locationName,
                    locationNameFriendly: this.models.selectedLocation.friendly,
                    websiteId: this.models.selectedLocation.websiteId,
                } );
                // Temporary code to notify Super Admins of credential change
                await new Promise( ( resolve ) => setTimeout( resolve, 100 ) );

                const hasPermissions = this.$store.getters[ 'User/hasPermissions' ];
                const rolesForCurrentLocation = this.$store.getters[ 'User/rolesForCurrentLocation' ];

                if ( hasPermissions && rolesForCurrentLocation.some( ( role ) => role.name === 'SUPER_ADMIN' ) ) {
                    await this.$store.dispatch( 'snackbar', {
                        message: 'The “Super Admin” role is going to be restricted as part of an update to our access management.\n'
                            + 'Users will be assigned new roles with permissions specific to their responsibilities.\n'
                            + 'Please contact the IT department with any questions.',
                        type: 'warning',
                        duration: -1,
                        top: true,
                        right: true,
                    } );
                }
            }
        },
    },
};
</script>

<style scoped lang="scss">

.location-box {
    &__actions {
        display: flex;
        align-items: center;
        margin: auto;
        padding: 1.5rem;
    }
    &__selection {
        margin-right: 2rem;
    }
}
</style>
